import { createActionGroup, emptyProps, props } from '@ngrx/store'

export const WorkflowBuilderActions = createActionGroup({
  source: 'WorkflowBuilder',
  events: {
    sendMessage: props<{
      message: string
      model?: string | null
      thread_id: string
      decision?: string | null
      tool_name?: string | null
      feedback?: any | null
      resource_id?: string | null
      resource_definition_id?: string | null
      context?: any | null
    }>(),
    getResponseStream: props<{ response: any }>(),
    getResponseFailure: props<{ error: string }>(),
    getResponseStreamCompleted: emptyProps(),
    cancelPendingRequest: emptyProps(),
    clearMessages: emptyProps(),
    addInitialMessage: props<{ initialMessage: string }>(),
  },
})
